import Firebase from 'firebase';
import 'firebase/firestore';
import 'firebase/auth';

var config = require('../config/default.json');

const firebase = Firebase.initializeApp({
	apiKey: config.firebaseApiKey,
	authDomain: 'kavtek-ambria-production.firebaseapp.com',
	databaseURL: 'https://kavtek-ambria-production-default-rtdb.firebaseio.com',
	projectId: 'kavtek-ambria-production',
	storageBucket: 'kavtek-ambria-production.appspot.com',
	messagingSenderId: '824632860411',
	appId: config.firebaseAppId,
});

// const firebase = Firebase.initializeApp(firebaseConfig);

export default firebase;
